import React from "react";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";

import { ResponsiveAccordion } from "./ResponsiveAccordion";
import { useFooterClickEventTracker } from "./useFooterClickEventTracker";

export const DispensaryQuickLinks = () => {
  const isCanada = useSelector(getDomainCountryCode) === "CA";
  const { createPublishFooterClickEventFunction } =
    useFooterClickEventTracker();

  return (
    <ResponsiveAccordion
      label={isCanada ? "Stores in" : "Dispensaries in"}
      ariaControlsName="nav__stores"
      defaultExpanded={false}
    >
      <ul className="font-medium text-sm text-green font-bold" id="nav__stores">
        {isCanada ? (
          <>
            <li className="py-sm">
              <a
                href={`/dispensaries/british-columbia`}
                onClick={createPublishFooterClickEventFunction(
                  "british columbia stores"
                )}
              >
                British Columbia
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/ontario`}
                onClick={createPublishFooterClickEventFunction(
                  "ontario stores"
                )}
              >
                Ontario
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/alberta`}
                onClick={createPublishFooterClickEventFunction(
                  "alberta stores"
                )}
              >
                Alberta
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/saskatchewan`}
                onClick={createPublishFooterClickEventFunction(
                  "saskatchewan stores"
                )}
              >
                Saskatchewan
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/manitoba`}
                onClick={createPublishFooterClickEventFunction(
                  "manitoba stores"
                )}
              >
                Manitoba
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/prince-edward-island`}
                onClick={createPublishFooterClickEventFunction(
                  "prince edwards island stores"
                )}
              >
                Prince Edward Island
              </a>
            </li>
          </>
        ) : (
          <>
            <li className="py-sm">
              <a
                href={`/dispensaries/california/los-angeles`}
                onClick={createPublishFooterClickEventFunction(
                  "los angeles dispensaries"
                )}
              >
                Los Angeles
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/washington/seattle`}
                onClick={createPublishFooterClickEventFunction(
                  "seattle dispensaries"
                )}
              >
                Seattle
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/oregon/portland`}
                onClick={createPublishFooterClickEventFunction(
                  "portland dispensaries"
                )}
              >
                Portland
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/california/san-francisco`}
                onClick={createPublishFooterClickEventFunction(
                  "san francisco dispensaries"
                )}
              >
                San Francisco
              </a>
            </li>
            <li className="py-sm">
              <a
                href="https://leafly.ca/dispensaries/ontario/toronto"
                onClick={createPublishFooterClickEventFunction(
                  "toronto dispensaries"
                )}
              >
                Toronto
              </a>
            </li>
            <li className="py-sm">
              <a
                href={`/dispensaries/michigan/detroit`}
                onClick={createPublishFooterClickEventFunction(
                  "detroit dispensaries"
                )}
              >
                Detroit
              </a>
            </li>
          </>
        )}
      </ul>
    </ResponsiveAccordion>
  );
};
